import { useEffect, useState } from 'react';
import { useLang } from 'models/langContext';

export const useAppLanguageCode = () => {
  const [appLanguageCode, setAppLanguageCode] = useState('');
  const { getLanguagesData, languages } = useLang();

  useEffect(() => {
    getLanguagesData();
  }, []);

  useEffect(() => {
    if (languages.length) {
      const browserLang = languages.find((lang) => navigator.language.includes(lang.code));
      const defaultLang = languages.find((lang) => lang.defaultLanguage);
      setAppLanguageCode(browserLang?.code || defaultLang?.code || '');
    }
  }, [languages]);
  return { appLanguageCode };
};
